class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const drawerInner = this.querySelector('.drawer__inner');
    if (drawerInner.classList.contains('is-empty')) {
      drawerInner.classList.remove('is-empty');
    }

    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (sectionElement) {
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    });

    // ✅ Fix: Restore missing "Cart" label after cart icon bubble update
    const restoreCartLabel = () => {
      const cartBubble = document.getElementById('cart-icon-bubble');
      if (!cartBubble) return;

      const hasCartIcon = cartBubble.querySelector('svg.icon');
      const hasLabel = cartBubble.querySelector('.header-icon-text');

      if (hasCartIcon && !hasLabel) {
        const lineBreak = document.createElement('br');
        const label = document.createElement('span');
        label.className = 'header-icon-text';
        label.textContent = 'Cart';
        cartBubble.appendChild(lineBreak);
        cartBubble.appendChild(label);
      } else if (!hasCartIcon) {
        requestAnimationFrame(restoreCartLabel);
      }
    };

    requestAnimationFrame(restoreCartLabel);

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  connectedCallback() {
    // Start watching cart icon for updates
    this.observeCartIcon();
  }

  renderContents(parsedState) {
    super.renderContents(parsedState);
    this.restoreCartLabel(); // failsafe after re-render
  }

  observeCartIcon() {
    const cartBubble = document.getElementById('cart-icon-bubble');
    if (!cartBubble) return;

    const observer = new MutationObserver(() => {
      this.restoreCartLabel();
    });

    observer.observe(cartBubble, {
      childList: true,
      subtree: true,
    });

    // Initial check
    this.restoreCartLabel();
  }

  restoreCartLabel() {
    const cartBubble = document.getElementById('cart-icon-bubble');
    if (!cartBubble) return;

    const hasCartIcon = cartBubble.querySelector('svg.icon');
    const hasLabel = cartBubble.querySelector('.header-icon-text');

    if (hasCartIcon && !hasLabel) {
      const lineBreak = document.createElement('br');
      const label = document.createElement('span');
      label.className = 'header-icon-text';
      label.textContent = 'Cart';
      cartBubble.appendChild(lineBreak);
      cartBubble.appendChild(label);
    }
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

